(function (window) {
  const primaryHero = document.querySelector('.primary-hero[data-opacity]');

  if (primaryHero) {
    const primaryHeroOverlay = primaryHero.querySelector('.primary-hero--overlay');
    const primaryHeroButton = primaryHero.querySelector('.primary-hero__cta');

    primaryHeroOverlay.style.opacity = primaryHero.getAttribute('data-opacity');
    primaryHeroButton.style.cssText = `
    background-color: ${primaryHeroButton.getAttribute('data-btnBackgroundColor')}; 
    color: ${primaryHeroButton.getAttribute('data-btnFontColor')};
    border-color: ${primaryHeroButton.getAttribute('data-btnOutline')};
`;
  }
})(this);